import { render, staticRenderFns } from "./LessonForm.vue?vue&type=template&id=815142c4&scoped=true"
import script from "./LessonForm.vue?vue&type=script&lang=js"
export * from "./LessonForm.vue?vue&type=script&lang=js"
import style0 from "./LessonForm.vue?vue&type=style&index=0&id=815142c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815142c4",
  null
  
)

export default component.exports